import { render, staticRenderFns } from "./TimeBox.vue?vue&type=template&id=1b53a93c&scoped=true&"
import script from "./TimeBox.vue?vue&type=script&lang=js&"
export * from "./TimeBox.vue?vue&type=script&lang=js&"
import style0 from "./TimeBox.vue?vue&type=style&index=0&id=1b53a93c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b53a93c",
  null
  
)

export default component.exports